import { Box } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildPerformanceInsightsSummaryDatatableFilter,
  usePerformanceInsightsSummaryDatatable,
} from 'generated/resources/datatable.graphql'
import { ProjectForSelectFragment } from 'generated/resources/graphql'

import useFilter from 'modules/core/components/Filter/base/useFilter'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ProjectSelector } from 'modules/project_management/components/selectors/ProjectSelector'

const ProjectsFilterComponent = () => {
  const { value, onValueChange } = useFilter<ProjectForSelectFragment[]>()

  return (
    <Box width="s400" flexDirection="column" overflowY="hidden" overflowX="hidden" hideScrollBar>
      <ProjectSelector
        multiple
        hideBorder
        alwaysOpen
        label={''}
        value={value ?? []}
        onChange={onValueChange}
      />
    </Box>
  )
}

const projectsFilter = (source: ReturnType<typeof usePerformanceInsightsSummaryDatatable>) => {
  return buildPerformanceInsightsSummaryDatatableFilter(source, {
    title: i18n.t('performance_process.analytics.datatable.filters.project'),
    path: 'project',
    identifier: 'projectIds',
    type: FilterType.Entity,
    default: false,
    categories: [
      {
        kind: 'Entity',
        operation: 'in',
        nameAttribute: 'name',
        component: () => <ProjectsFilterComponent />,
      },
    ],
    onUpdateValue(value) {
      track(trackingEvents.performanceAnalytics.insightsSummaryFilterApplied, {
        type: 'projectIds',
        value,
      })
    },
  })
}

export default projectsFilter
